import React, { Component } from 'react'
import axios from 'axios'
import greenMark from '../../images/green_mark.svg'

class Screen9A extends Component {

  state = {
    status: <h2>Prijava se šalje...</h2>
  }

  componentDidMount() {
    let app = this
    const { language, t } = this.props
    let formData = new FormData()

    Object.keys(this.props.entry).map(e =>
      formData.set(e, this.props.entry[e])
    )
    axios.post('https://dostajemrznje.org/api/save2', formData)
    .then(function (response) {
      app.setState({status: <div>
          <img src={greenMark} alt={t(language, 'logo')} />
          <h2>{t(language, 'successTitle')}</h2>
          <h2>{t(language, 'thanks')}</h2>
          <p style={{textAlign: 'center'}}>{t(language, 'reviewTeam')}</p>
        </div>})
    })
    .catch(function (error) {
      app.setState({status: <h3><br /><br />{t(language, 'errorSubmitting')}<br /><br />{t(language, 'tryAgain')}</h3>})
    });
  }

  render() {

    return (
      <main className="last_screen">
        {this.state.status}
      </main>
    );
  }
}

export default Screen9A;
